// removed by extract-text-webpack-plugin
module.exports = {"SearchToggle":"u5vIKcrhgyJwesefVOoIc","icon":"_3E7GQX4Cb5Bd_mz3E8un6m"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SearchToggle/SearchToggle.css
// module id = 261
// module chunks = 8